module.exports = __webpack_public_path__ + "img/2-lg.f5260716.jpg";